export const extractGamesAppVersion = (userAgent: string) => {
  return userAgent.match(/WTGamesApp\/([^\s]+)/)?.[1] ?? '';
};
